module.exports = "https://la-static.vkplay.ru/promo/newstart/img/feature-pvp.f0f81d80.jpg";